import "./login.scss";

const Login = () => {
  return (
    <div>
      Login Page
    </div>
  )
}

export default Login
